import { Avatar, Box, Flex, IconButton, Text, VStack, Select, Button, SlideFade, HStack, FormLabel, Stack, Card, CardHeader, Heading, CardBody } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom';
import './Dashboard.css'
import Logo from './Logo.svg'
import Premium from './Premium';

export default function Dashboard() {
  const { guild_id, section: urlSection, sub_section } = useParams();

  const DISCORD_API_VERSION = 10;
  const DISCORD_API = `https://discord.com/api/v${DISCORD_API_VERSION}`

  const [sessionData, setSessionData] = useState(null);

  const [isDirty, setIsDirty] = useState(false)
  const [guildConfig, _setGuildConfig] = useState({});

  const setGuildConfig = data => {
    setIsDirty(true)
    _setGuildConfig(prev => ({ ...prev, ...data }))
    console.log(guildConfig)
  }

  const [guildChannels, setGuildChannels] = useState(null);
  // const [guildRoles, setGuildRoles] = useState(null);
  const [customBrandedBot, setCustomBrandedBot] = useState(null);
  const [section, setSection] = useState('forms')
  const [sidebar, setSidebar] = useState(false)

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isRestting, setIsResetting] = useState(false)

  const reset = async () => {
    setIsResetting(true)
    let getGuildInfo = await fetch(`https://discord-forms.pages.dev/api/guilds/${guild_id}`, {
      credentials: 'include' // This is important to send cookies with the request
    });
    console.log(getGuildInfo.status)
    getGuildInfo = await getGuildInfo.json()
    setGuildConfig(getGuildInfo.guildConfig)
    setIsResetting(false)
  }

  function useScreenWidth(size) {
    const [width, setWidth] = useState(0)

    useEffect(() => {
      function handleResize() {
        setWidth(window.innerWidth)
      }

      window.addEventListener("resize", handleResize)

      handleResize()

      return () => {
        window.removeEventListener("resize", handleResize)
      }
    }, [setWidth])

    return width > size
  }

  const isSmallScreen = !useScreenWidth(1000);



  useEffect(() => {
    const fetchSession = async () => {
      try {
        const response = await fetch('https://discord-forms.pages.dev/session', {
          credentials: 'include' // This is important to send cookies with the request
        });
        if (!response.ok) window.location.replace('https://discord.com/oauth2/authorize?client_id=942858850850205717&response_type=code&redirect_uri=https%3A%2F%2Fdiscord-forms.pages.dev%2Fredirect&scope=identify+guilds&prompt=none');


        const data = await response.json();
        setSessionData(data);
        console.log('data', data)
        console.log('data', JSON.stringify(data, null, 2))
        console.log('guild_id', guild_id)
        let getGuildInfo = await fetch(`https://discord-forms.pages.dev/api/guilds/${guild_id}`, {
          credentials: 'include' // This is important to send cookies with the request
        });
        console.log(getGuildInfo.status)
        // if (!getGuildInfo.ok) window.location.replace('https://discord.com/oauth2/authorize?client_id=942858850850205717&response_type=code&redirect_uri=https%3A%2F%2Fdiscord-forms.pages.dev%2Fredirect&scope=identify+guilds&prompt=none');
        // if (!getGuildInfo.ok) window.location.replace('https://create.discordforms.com/');
        getGuildInfo = await getGuildInfo.json()
        console.log('getGuildInfo', getGuildInfo)

        if (getGuildInfo.guildConfig.custom_branding) {
          let getCustomBrandedBot = await fetch(`${DISCORD_API}/users/@me`, {
            method: 'GET',
            headers: { Authorization: `Bot ${getGuildInfo.guildConfig.custom_branding.token}` }
          });
          if (getCustomBrandedBot.ok) {
            getCustomBrandedBot = await getCustomBrandedBot.json()
            setCustomBrandedBot(getCustomBrandedBot)
          }
        }

        // for(let i = 0; i < getGuildInfo.guildConfig.forms.length; i++) {
        //   getGuildInfo.guildConfig.forms[i].on_submit = {
        //     ADD_ROLE_TO_SUBMITTER: '',
        //     REMOVE_ROLE_FROM_SUBMITTER: ''
        //   }
        // }

        _setGuildConfig({ ...getGuildInfo.guildConfig });

        setGuildChannels(getGuildInfo.guildChannels)
        // setGuildRoles(getGuildInfo.guildRoles)
      } catch (err) {
        console.log(err)
        // window.location.replace('https://discord.com/oauth2/authorize?client_id=942858850850205717&response_type=code&redirect_uri=https%3A%2F%2Fdiscord-forms.pages.dev%2Fredirect&scope=identify+guilds&prompt=none');
      }
    };

    fetchSession();
    if (urlSection) {
      setSection(`${urlSection}${sub_section ? ` ${sub_section}` : ''}`)
    } else {
      window.history.replaceState({}, "", `https://discord-forms.pages.dev/dashboard/${guild_id}/forms`)
    }
  }, [guild_id, urlSection, sub_section, DISCORD_API]);

  const onSubmit = async (data) => {
    setIsSubmitting(true)
    setIsDirty(false)
    console.log(data)
    await fetch(`/api/guilds/${guild_id}`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
    setIsSubmitting(false)
  }

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isDirty) {
        event.preventDefault();
        event.returnValue = '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isDirty]);

  return (
    <Box bg='rgb(27, 32, 40)' color='rgba(255, 255, 255, 80%)' height='100vh'>
      <Flex bg='rgb(27, 32, 40)' width='100%' height='80px' px='20px' alignItems='center'>
        <svg style={{ display: isSmallScreen ? 'block' : 'none' }} height='24px' width='24px' cursor='pointer' onClick={() => setSidebar(!sidebar)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14"><g><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M0.5 1.5h13" stroke-width="1" /><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M0.5 7h13" stroke-width="1" /><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M0.5 12.5h13" stroke-width="1" /></g></svg>
        <Flex justifyContent='center' gap={2} ml={isSmallScreen ? `${((window.innerWidth - 118.047) / 2) - 44}px` : '71px'}>
          <Link to='/dashboard'><Avatar name='Forms' src={Logo} userSelect='none' width='40px' height='40px' bg='oklab(0.321088 -0.000220731 -0.00934622)' className='logo' /></Link>
          <Text userSelect='none' fontWeight='Bold' fontSize='24px' color='white'>Forms</Text>
        </Flex>
      </Flex>
      <Flex>
        <Box id='sidebar' display={!sidebar && isSmallScreen ? 'none' : 'block'} width={isSmallScreen ? '100%' : '300px'}>
          <Flex justifyContent='space-between' direction='column' height='calc(100vh - 80px)' pb='20px'>
            <Box>
              <Flex className='sidebar-element' background={section.startsWith('forms') ? '#212831' : 'transparent'} onClick={() => { setSection('forms'); setSidebar(false); window.history.pushState({}, "", `https://discord-forms.pages.dev/dashboard/${guild_id}/forms`); }}>
                <svg className='sidebar-element-icon' xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14"><g><path stroke="currentcolor" d="M4.17349 2.10889c-0.25729 0.02946 -0.60252 0.06018 -0.85608 0.09067 -0.24071 0.02894 -0.47967 0.05767 -0.71681 0.08492 -0.49602 0.05701 -0.88913 0.44564 -0.92587 0.93465 -0.23427 3.11835 -0.23427 6.06189 0 9.18027 0.03674 0.489 0.43009 0.8788 0.92783 0.9188 3.02054 0.2425 5.77459 0.2425 8.79514 0 0.4977 -0.04 0.8911 -0.4298 0.9278 -0.9188 0.2343 -3.11838 0.2343 -6.06192 0 -9.18027 -0.0367 -0.48901 -0.4298 -0.87764 -0.9259 -0.93465 -0.2371 -0.02725 -0.4761 -0.05598 -0.7168 -0.08492 -0.2535 -0.03049 -0.6081 -0.06121 -0.86532 -0.09067" stroke-width="1" /><path stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" d="M8.3045 0.54519c0.97879 0.037253 1.52665 0.52425 1.52665 1.36417 0 0.83991 -0.54786 1.3269 -1.52665 1.36416 -1.58314 0.06025 -1.02528 0.06025 -2.60842 0 -0.97879 -0.03726 -1.52665 -0.52425 -1.52665 -1.36416 0 -0.83992 0.54786 -1.326918 1.52665 -1.36417 1.58314 -0.060253 1.02528 -0.060253 2.60842 0Z" stroke-width="1" /><path stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" d="M4.63147 6.51001h4.73706" stroke-width="1" /><path stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" d="M4.63147 9.16626h2.85857" stroke-width="1" /></g></svg>
                <Text className='sidebar-element-text'>Forms</Text>
              </Flex>
              <Flex className='sidebar-element sidebar-element-premium' background={section.startsWith('premium') ? '#212831' : 'transparent'} onClick={() => { setSection('premium'); setSidebar(false); window.history.pushState({}, "", `https://discord-forms.pages.dev/dashboard/${guild_id}/premium`); }}>
                <svg className='sidebar-element-icon sidebar-element-premium' style={{ transition: 'color 1s' }} color={guildConfig ? (guildConfig.license ? 'inherit' : '#00A0DC') : 'inherit'} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14"><g><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M13.5 3.95087v1.19498c-0.7385 0.31535 -1.2553 1.04135 -1.2553 1.88656s0.5168 1.57121 1.2553 1.88656V10.114c0 1.1345 -0.8252 1.8936 -2.08 2.0543 -3.45172 0.4421 -5.38218 0.445 -8.84 0C1.35994 12.0113 0.5 11.2485 0.5 10.114l0 -1.19498c0.73859 -0.31532 1.25544 -1.04135 1.25544 -1.88661 0 -0.84526 -0.51685 -1.57129 -1.25544 -1.88661l0 -1.19493c0 -1.1346 0.86828 -1.85141 2.08 -2.05437 3.41677 -0.57229 5.37402 -0.48623 8.84 0 1.1461 0.16079 2.08 0.91977 2.08 2.05437Z" strokeWidth={1} /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M6.62962 4.3598c0.1359 -0.33138 0.60519 -0.33138 0.74109 0l0.56281 1.37235 1.52351 0.13354c0.35741 0.03133 0.49648 0.48068 0.21924 0.70843l-0.93022 0.76416c-0.11595 0.09525 -0.16892 0.24733 -0.13724 0.39401l0.30474 1.4109c0.07601 0.35193 -0.31481 0.61761 -0.6141 0.41746l-1.29928 -0.8689 -1.29928 0.8689c-0.29929 0.20015 -0.69012 -0.06553 -0.6141 -0.41746l0.30474 -1.4109c0.03168 -0.14668 -0.0213 -0.29876 -0.13725 -0.39401l-0.93022 -0.76416c-0.27724 -0.22775 -0.13817 -0.6771 0.21925 -0.70843l1.5235 -0.13354 0.56281 -1.37235Z" strokeWidth={1} /></g></svg>
                <Text className='sidebar-element-text sidebar-element-premium' transition='color 1s' color={guildConfig ? (guildConfig.license ? 'inherit' : '#00A0DC') : 'inherit'}>Premium</Text>
              </Flex>
              {/* <Flex className='sidebar-element' background={section.startsWith('custom-branding') ? '#212831' : 'transparent'} onClick={() => { setSection('custom-branding'); setSidebar(false); window.history.pushState({}, "", `https://discord-forms.pages.dev/dashboard/${guild_id}/custom-branding`); }}>
                <svg className='sidebar-element-icon' xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14"><g><path id="Intersect" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" d="m3.17188 12.5625 0.12377 -0.528c0.20645 -0.7775 0.65299 -1.4723 1.27877 -1.9838 0.68452 -0.55951 1.54143 -0.86515 2.42552 -0.86515s1.74099 0.30564 2.42552 0.86515c0.62574 0.5115 1.07234 1.2063 1.27874 1.9838l0.1239 0.5436" stroke-width="1"></path><path id="Vector" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" d="M7 13.5c4.16 0 6.5 -2.34 6.5 -6.5S11.16 0.5 7 0.5 0.5 2.84 0.5 7s2.34 6.5 6.5 6.5Z" stroke-width="1"></path><path id="Vector_2" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" d="M6.99927 7.57996c1.4 0 2.1875 -0.7875 2.1875 -2.1875s-0.7875 -2.1875 -2.1875 -2.1875 -2.1875 0.7875 -2.1875 2.1875 0.7875 2.1875 2.1875 2.1875Z" stroke-width="1"></path></g></svg>
                <Text className='sidebar-element-text'>Custom Branding</Text>
              </Flex> */}
            </Box>
            <a href='https://discord.com/invite/hBbgEBYNSP' target='_blank' rel="noopener noreferrer"><Flex className='sidebar-element sidebar-link'>
              <svg className='sidebar-element-icon' xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14"><g><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M4.61523 6.99988c-0.32 0 -0.5 -0.18 -0.5 -0.5s0.18 -0.5 0.5 -0.5" strokeWidth={1} /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M4.61816 6.99988c0.32 0 0.5 -0.18 0.5 -0.5s-0.18 -0.5 -0.5 -0.5" strokeWidth={1} /><path id="Union_3" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M9.38281 6.99988c-0.32 0 -0.5 -0.18 -0.5 -0.5s0.18 -0.5 0.5 -0.5" strokeWidth={1} /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M9.38574 6.99988c0.32 0 0.5 -0.18 0.5 -0.5s-0.18 -0.5 -0.5 -0.5" strokeWidth={1} /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M4.5794 11.6545c-0.23594 0.3082 -0.63928 0.4278 -1.01104 0.2868 -0.83161 -0.3154 -1.47456 -0.7126 -2.11533 -1.2531C0.781186 10.1215 0.434542 9.24285 0.510249 8.37638c0.173218 -1.98249 0.703371 -3.98251 1.433081 -5.45356 0.11644 -0.23475 0.3282 -0.39784 0.57425 -0.47381 0.12422 -0.03835 0.24087 -0.07597 0.35292 -0.1121 0.65781 -0.21213 1.1567 -0.37302 2.09582 -0.32988 0.28146 0.01293 0.53844 0.16025 0.71138 0.38443 0.4493 -0.02967 0.90422 -0.04882 1.36389 -0.04882 0.43269 0 0.86115 0.01697 1.28468 0.0437 0.1729 -0.2213 0.4281 -0.36647 0.70741 -0.37931 0.93912 -0.04314 1.43802 0.11775 2.09582 0.32988 0.112 0.03613 0.2287 0.07375 0.3529 0.1121 0.2461 0.07597 0.4578 0.23906 0.5743 0.47381 0.7297 1.47105 1.2598 3.47107 1.4331 5.45356 0.0757 0.86647 -0.271 1.74512 -0.9428 2.31182 -0.6408 0.5405 -1.2838 0.9377 -2.1154 1.2531 -0.3717 0.141 -0.77506 0.0214 -1.011 -0.2868 -0.34447 -0.4499 -0.64148 -0.8981 -0.89159 -1.3503 -0.48939 0.0344 -0.98556 0.0572 -1.48742 0.0572 -0.52922 0 -1.05213 -0.0254 -1.56743 -0.063 -0.25077 0.4542 -0.54883 0.9043 -0.89476 1.3561Z" strokeWidth={1} /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M4.10547 10.0928c0.78547 0.3371 4.69149 0.3792 5.49833 0" strokeWidth={1} /></g></svg>
              <Text className='sidebar-element-text'>Support Server</Text>
            </Flex></a>
          </Flex>
        </Box>
        <Box id='content' display={(isSmallScreen && sidebar) ? 'none' : 'block'} width={isSmallScreen ? '100%' : 'calc(100% - 300px)'}>
          {sessionData && guildConfig.forms ? <>
            <form onSubmit={onSubmit}>
              {section === 'forms' && <>
                <HStack alignItems='center' justifyContent='space-between'>
                  <HStack gap={2} alignItems='center'>
                    <Text fontWeight='bold' fontSize='22px' color='white'>Forms</Text>
                    <Text fontWeight='bold' fontSize='12px' mt='2px' background='rgba(189,189,189,.05)' borderRadius='100px' padding='3px 9px' >{Object.keys(guildConfig.forms).length}<span style={{ color: 'white' }}> / </span>25</Text>
                  </HStack>
                  <a href='https://create.discordforms.com/' target='_blank' rel='noopener noreferrer'><Button color='white' background='rgba(255, 255, 255, 0.1)' fontSize='14px' height='35px' borderRadius='8px' padding='0 12px' _hover={{ background: 'rgba(255, 255, 255, 0.2)' }}>New Form</Button></a>
                </HStack>

                <VStack align='flex-start' gap='24px' mt='12px'>
                  {Object.entries(guildConfig.forms).map(([id, form]) => <Flex bg='rgba(189,189,189,.05)' justifyContent='space-between' alignItems='center' color='white' borderRadius='8px' width='100%' p='24px'>
                    <Text>{form?.pages?.[0].modal.title || form.modal.title}</Text>
                    <HStack gap={4}>
                      <IconButton onClick={() =>
                        setGuildConfig(prev => {
                          const newForms = { ...prev.forms };
                          delete newForms[id];
                          return { ...prev, forms: newForms };
                        })
                      } color='rgb(255, 107, 134)' borderRadius='.5rem' bg='rgba(255, 107, 134, 0.14)' _hover={{ background: 'rgba(255, 107, 134, 0.25)' }} icon={<svg width='18px' height='18px' xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14"><g><path id="Vector 195" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M1.5 4.01121c3.70225 -0.48695 7.29775 -0.48695 11 0" strokeWidth={1} /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M2.48113 3.89331c-0.03491 1.86889 -0.08342 5.02765 0.49568 7.61009 0.22419 0.9997 1.07518 1.7149 2.08968 1.8579 0.65577 0.0925 1.25364 0.1387 1.93361 0.1387 0.68 0 1.27796 -0.0462 1.93382 -0.1387 1.0145 -0.143 1.86548 -0.8582 2.08968 -1.8579 0.5791 -2.58241 0.5306 -5.74115 0.4957 -7.61005 -3.03257 -0.32979 -6.00563 -0.32981 -9.03817 -0.00004Z" strokeWidth={1} /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M4.41786 3.70312c-0.00772 -0.10103 -0.01161 -0.50235 -0.01161 -0.60949C4.40625 1.43371 5.33996 0.5 6.99988 0.5s2.59363 0.93371 2.59363 2.59363c0 0.10714 -0.00389 0.50846 -0.01162 0.60949" strokeWidth={1} /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M5.3476 6.40408c-0.05908 1.0462 -0.00048 2.90177 0.18132 4.24122m2.94168 0c0.18175 -1.33949 0.24026 -3.19505 0.18117 -4.24125" strokeWidth={1} /></g></svg>} />
                      <IconButton onClick={() => setSection(`forms ${id}`)} color='white' borderRadius='.5rem' bg='rgb(255 255 255 / 10%)' _hover={{ background: 'rgb(255 255 255 / 10%)' }} icon={<svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path stroke='currentcolor' d="M9.31 10.448l4.57-4.57a3 3 0 014.241 4.243l-4.57 4.57a15.501 15.501 0 01-7.2 4.077l-.884.22a.376.376 0 01-.455-.455l.22-.883a15.501 15.501 0 014.078-7.202z"></path><path d="M17.25 10.992c-2.121.707-4.95-2.121-4.242-4.242m.871-.871l-4.57 4.57a15.501 15.501 0 00-4.077 7.2l-.22.884a.376.376 0 00.455.455l.883-.22a15.501 15.501 0 007.202-4.078l4.57-4.57a3 3 0 10-4.243-4.241z" stroke="currentcolor" stroke-width="1.5"></path></svg>} />
                    </HStack>
                  </Flex>)}
                </VStack>
              </>}
              {section.split(' ')[0] === 'forms' && section.split(' ').length === 2 && <>
                <Flex alignItems='center'>
                  <svg onClick={() => setSection(section.split(' ').slice(0, -1).join(' '))} cursor="pointer" style={{ marginRight: '18px' }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.5 17l-5-5 5-5" stroke="#9B9D9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                  <Text fontWeight='Bold' fontSize='22px' color='white'>Edit {guildConfig.forms[section.split(' ')[1]]?.pages?.[0].modal.title || guildConfig.forms[section.split(' ')[1]].modal.title}</Text>
                </Flex>
                {guildConfig.forms[section.split(' ')[1]].submit_channel_id && <Stack gap={2}>
                  <Box>
                    <FormLabel>Submission Channel</FormLabel>
                    <Select
                      onChange={(event) => {
                        const formId = section.split(' ')[1];
                        setGuildConfig(prev => {
                          const newForms = { ...prev.forms, [formId]: { ...prev.forms[formId], submit_channel_id: event.target.value } };
                          return { ...prev, forms: newForms };
                        });
                      }}
                      height="48px!important"
                      maxWidth='500px'
                      bg='rgb(23, 24, 30)'
                      border='none'
                      // borderWidth="2px"
                      // borderColor="transparent"
                      borderRadius="8px"
                      // border='1px solid rgba(255, 255, 255, 0.16)'
                      _focus={{ outline: 'none' }}
                      _focusVisible={{ outline: 'none' }}
                      _hover={{ border: "none" }}
                      // onChange={(event) => {
                      //   setSubmissionChannel('edit', event.target.value, index)
                      // }}
                      value={guildConfig.forms[section.split(' ')[1]].submit_channel_id}
                    >
                      {guildChannels.filter(channel => [0, 5, 10, 11, 12, 15, 16].includes(channel.type)).map(channel => <option value={channel.id}>#{channel.name}</option>)}
                    </Select>
                  </Box>
                  <Card bg='#1b2028'>
                    <CardHeader>
                      <Heading size='md' color='white'>Give or remove roles on submission</Heading>
                    </CardHeader>
                    <CardBody>
                      <Stack spacing='4'>
                        <Box color='rgba(255,255,255,.8)'>
                          <FormLabel>Role ID to give</FormLabel>
                          {/* <Select
                            {...register(`forms.${section.split(' ')[1]}.on_submit.ADD_ROLE_TO_SUBMITTER`)}
                            height="48px!important"
                            maxWidth='500px'
                            bg='rgb(23, 24, 30)'
                            border='none'
                            // borderWidth="2px"
                            // borderColor="transparent"
                            borderRadius="8px"
                            // border='1px solid rgba(255, 255, 255, 0.16)'
                            _focus={{ outline: 'none' }}
                            _focusVisible={{ outline: 'none' }}
                            _hover={{ border: "none" }}
                          // onChange={(event) => {
                          //   setSubmissionChannel('edit', event.target.value, index)
                          // }}
                          // value={guildConfig.forms[section.split(' ')[1]].submit_channel_id}
                            placeholder='None'
                          >
                            {guildRoles.map(role => <option value={role.id}>{role.name}</option>)}
                          </Select> */}
                          {/* <Input borderColor='rgba(255,255,255,.1)' {...register(`forms.${section.split(' ')[1]}.on_submit.ADD_ROLE_TO_SUBMITTER`)} /> */}
                        </Box>
                        <Box>
                          <FormLabel color='rgba(255,255,255,.8)'>Role ID to remove</FormLabel>
                          {/* <Input borderColor='rgba(255,255,255,.1)' {...register(`forms.${section.split(' ')[1]}.on_submit.REMOVE_ROLE_FROM_SUBMITTER`)} /> */}
                        </Box>
                      </Stack>
                    </CardBody>
                  </Card>

                  {/* register your input into the hook by invoking the "register" function */}
                  {/* <input {...register(`forms.${section.split(' ')[1]}.submit_channel_id`)} /> */}

                </Stack>}
              </>}
              {section === 'custom-branding' && <>
                {!guildConfig.custom_branding && <Text>Enable custom branding using the /help command in your server.</Text>}
                {customBrandedBot && <VStack gap={1} align='flex-start' width='500px'>
                  <Text fontWeight='Bold' fontSize='22px' color='white'>Custom Branding</Text>
                  <Box>
                    <FormLabel>Application ID</FormLabel>
                    {/* <Input {...register('custom_branding.id', { pattern: /^\d{10,20}$/ })} /> */}
                  </Box>
                  <Box>
                    <FormLabel>Public Key</FormLabel>
                    {/* <Input {...register('custom_branding.public_key')} /> */}
                  </Box>
                  <Box>
                    <FormLabel>Token</FormLabel>
                    {/* <Input {...register('custom_branding.token')} type='password' /> */}
                  </Box>
                  <Text>{JSON.stringify(customBrandedBot, null, 2)}</Text>
                </VStack>}
              </>}
              <SlideFade in={isDirty} offsetY='20px' style={{ position: 'fixed', bottom: '24px', width: `calc(100% - ${isSmallScreen ? 48 : 380}px)`, pointerEvents: isDirty ? 'auto' : 'none' }}>
                <Flex bg='rgb(23, 24, 30)' p='20px 20px 20px 30px' borderRadius='8px' justifyContent='space-between' alignItems='center'>
                  <Text fontSize='14px' color='white'>Careful - you have unsaved changes!</Text>
                  <HStack gap={2}>
                    <Button onClick={async () => {
                      await reset()
                      setIsDirty(false)
                    }} isLoading={isRestting} color='white' background='rgba(255, 255, 255, 0.1)' borderRadius='8px' padding='8px 16px' _hover={{ background: 'rgba(255, 255, 255, 0.2)' }}>Reset</Button>
                    <Button type='submit' isLoading={isSubmitting} color='white' background='rgb(57, 148, 255)' borderRadius='8px' padding='8px 16px' _hover={{ background: 'rgb(0, 118, 255)' }}>Save</Button>
                  </HStack>
                </Flex>
              </SlideFade>
              {/* <Text>the Dashboard for {guild_id} session id is {sessionData.id} guild config is {JSON.stringify(guildConfig, null, 2)} and data is {JSON.stringify(sessionData.data)}</Text> */}
            </form>
            {section === 'premium' && <Premium guildConfig={guildConfig} />}
          </> : <Text>Loading..</Text>}
        </Box>
      </Flex>
    </Box>
  )
}
